export * from './post-referenzen-hochladen.component';
export * from './post-referenzen-hochladen.component.module';